<template>
  <div styleName="opt_footer_wifi" @click="_showGraph" :data-status="availableNetwork">
    <div styleName="networkGraph" v-show="graphShow">
      <div styleName="graphHeader" :data-status="networkDelay">{{ $t('connection') }}
        <span styleName="desc">{{networkDesc}}</span>
      </div>
      <div styleName="notice">{{ $t('wifiDesc') }}</div>
      <div styleName="leftTip">
        <ul styleName="left">
          <li v-for="tag in leftTagNum[selectTagNum]" :key="`${tag}_${selectTagNum}`">{{tag}}</li>
        </ul>
        <div styleName="right">
          <span styleName="item" v-for="n in 10" :key="n"></span>
        </div>
      </div>
      <div styleName="bottomTip">
        <span>60s</span>
        <span>30s</span>
        <span>now</span>
      </div>
      <div styleName="graphInner">
        <chart styleName="echarts" :options="line" />
      </div>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import { mediaSDK, signalSdk } from '@/utils/getSDK'
import imgPreload from '@/utils/preImage'
import wifiOff from '@/assets/images/wifi-off.svg'
import { mapGetters } from 'vuex'
import Ping from '@/utils/ping'
let pInstance = new Ping({ favicon: 'https://openclass.vipkid.com.cn/favicon.ico' })
let lastGet = 0
let lastLost = 0
let lostRate = 0

export default {
  name: 'wifi',
  mixins: [CSSModules(styles)],
  data: function () {
    return {
      graphShow: false,
      networkDesc: '',
      networkDelay: 'great',
      networdData: [],
      xAxisData: [],
      leftTagNum: [[86, 57, 14], [324, 204, 84], [558, 343, 121], [1216, 685, 238], [2132, 1240, 452]],
      noticeText: '',
      availableNetwork: true,
      noticeShow: false,
      isOnce: false,
      isAudioNotChecked: false,
      // count: 1,
      current: 0
    }
  },
  computed: {
    ...mapGetters(['cameraStatus', 'audioStatus', 'enterRoomParams']),
    roomType () {
      console.log('------>', this.enterRoomParams.roomType)
      return this.enterRoomParams.roomType
    },
    line () {
      return {
        xAxis: {
          type: 'category',
          inverse: true,
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#EEEEEE'
            }
          },
          data: this.xAxisData
        },
        yAxis: {
          type: 'value',
          name: 'delay/ms',
          nameLocation: 'end',
          nameGap: 10,
          splitNumber: 5,
          nameTextStyle: {
            color: '#AAAAAA',
            fontSize: 10
          },
          max: 210,
          min: 0,
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            // interval: 1,
            lineStyle: {
              color: ['#EEEEEE']
            }
          }
        },
        grid: {
          left: 30,
          bottom: 18,
          top: 28,
          right: 30
        },
        series: [{
          symbol: 'none',
          data: this.networdData,
          type: 'line',
          lineStyle: {
            color: '#A5BC4E'
          },
          markPoint: {
            silent: true
          }
        }]
      }
    },
    selectTagNum () {
      if (this.current < 60) {
        return 0
      } else if (this.current < 90) {
        return 1
      } else if (this.current < 150) {
        return 2
      } else if (this.current < 180) {
        return 3
      } else {
        return 4
      }
    },
    deviceStatus () {
      return this.cameraStatus || this.audioStatus
    }
  },
  watch: {
    deviceStatus (val) {
      if (!val) {
        this.lostRateTimer && clearInterval(this.lostRateTimer)
        this.lostRateTimer = null
        if (!this.keepAliveListenerExit) {
          this.handleKeepAliveDelay()
        }
      }
    }
  },
  mounted () {
    // 离线状态图片的预加载
    imgPreload([wifiOff])

    // 初始化echarts中的数据
    this.networdData = []
    this.len = 0

    while (this.len < 12) {
      this.xAxisData.unshift(this.len++)
    }
    // 异常处理
    window.addEventListener('offline', () => {
      this.availableNetwork = false
    })
    window.addEventListener('online', () => {
      this.availableNetwork = true
    })

    signalSdk.on('KEEP_ALIVE_FAIL', () => {
      pInstance.ping('', (err) => {
        console.log('【PING 实例 err】', err)
        if (err) {
          this.$toast.show({
            header: false,
            headerDesc: this.$t('attention'),
            text: this.$t('disconnected'),
            buttonCount: 1,
            btnText: this.$t('btnok'),
            textStyle: {
              'text-align': 'center'
            }
          })
          // 如果确定为断网，每2秒发一次ping，成功之后立即刷新
          this.availableNetwork = false
          setInterval(function () {
            pInstance.ping('', (err) => {
              if (!err) {
                window.location.reload()
              }
            })
          }, 2000)
        }
      })
    })
  },
  methods: {
    _showGraph () {
      this.graphShow = !this.graphShow
      // 以丢包率或者信令时延作为网络状态的检测标准
      // 优先选择丢包率
      let localStream = mediaSDK.getLocalStream()
      if (localStream) {
        if (localStream.video) {
          if (this.lostRateTimer) return
          if (this.keepAliveListenerExit) {
            this.removeKeepAliveListener()
            this.keepAliveListenerExit = false
          }
          this.getNetStats(localStream, 'video')
          this.lostRateTimer = setInterval(() => {
            this.getNetStats(localStream, 'video')
          }, 5000)
        } else {
          if (this.lostRateTimer) {
            clearInterval(this.lostRateTimer)
            this.lostRateTimer = null
          }
          if (!this.keepAliveListenerExit) {
            this.handleKeepAliveDelay()
          }
        }
      } else {
        if (this.lostRateTimer) {
          clearInterval(this.lostRateTimer)
          this.lostRateTimer = null
        }
        this.handleKeepAliveDelay()
      }
    },
    getNetStats (localStream, kind) {
      // console.log()
      if (this.roomType === 1) {
        localStream.getStats((stats) => {
          console.log('========stats=======', stats)
          let get, lost
          get = Number(stats[`${kind}SendPackets`])
          lost = Number(stats[`${kind}SendPacketsLost`])
          if (get !== 0) {
            lostRate = (lost - lastLost) / ((get - lastGet) + (lost - lastLost))
          }
          lastGet = get
          lastLost = lost
          this.handleLostRate(lostRate)
        })
      }
      // console.log('localStream',Object.keys(localStream))

    },
    handleKeepAliveDelay () {
      signalSdk.on('KEEP_ALIVE_DEALYTIME', this.handleSignalDelay)
      this.keepAliveListenerExit = true
    },
    removeKeepAliveListener () {
      signalSdk.removeListener('KEEP_ALIVE_DEALYTIME', this.handleSignalDelay)
    },
    handleLostRate (lostRate) {
      let showLostRate
      if (lostRate <= 0.01) {
        this.networkDesc = this.$t('strong')
        this.networkDelay = 'great'
        this.availableNetwork = true
        showLostRate = Math.random() * 30 + 30
      } else if (lostRate > 0.01 && lostRate <= 0.2) {
        this.networkDesc = this.$t('ok')
        this.networkDelay = 'medium'
        this.availableNetwork = true
        if (lostRate < 0.05) {
          showLostRate = Math.random() * 30 + 60
        } else if (lostRate < 0.1) {
          showLostRate = Math.random() * 30 + 90
        } else {
          showLostRate = Math.random() * 30 + 120
        }
      } else {
        this.networkDesc = this.$t('poor')
        this.networkDelay = 'bad'
        this.availableNetwork = false
        showLostRate = 210
      }
      if (this.networdData.length > 11) {
        this.networdData.pop()
        this.xAxisData.pop()
        this.xAxisData.unshift(this.len++)
      }
      this.current = showLostRate
      this.networdData.unshift(showLostRate)
    },
    handleSignalDelay (time) {
      if (time <= 50) {
        this.networkDesc = this.$t('strong')
        this.networkDelay = 'great'
        this.availableNetwork = true
        time = Math.random() * 30 + 30
      } else if (time <= 500) {
        this.networkDesc = this.$t('ok')
        this.networkDelay = 'medium'
        this.availableNetwork = true
        if (time > 160) {
          time = Math.random() * 30 + 120
        }
      } else {
        this.networkDesc = this.$t('poor')
        this.networkDelay = 'bad'
        this.availableNetwork = false
        time = 210
      }
      if (this.networdData.length > 11) {
        this.networdData.pop()
        this.xAxisData.pop()
        this.xAxisData.unshift(this.len++)
      }
      this.current = time
      this.networdData.unshift(time)
    }
  },
  components: {
    chart: ECharts
  }
}
</script>
